import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { OrderBuilderStatus } from "../../store/constants";
import Loading from "../../../../components/Loading/Loading";
import { get, set } from "lodash";
import { Row, Col, Button, Form } from "react-bootstrap";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import EarPiecesFamilyModel from "../EarPiecesFamilyModel/EarPiecesFamilyModel";
import RepairFamilyModel from "../RepairFamilyModel/RepairFamilyModel";
import EarImpression from "../EarImpression/EarImpression";
import config from "../../../../config";
// import { selectClasses } from "@mui/material";

import(/* webpackChunkName: "order-builder-ite" */ "./repairItemBuilder.scss");

const RepairItemBuilder = ({
  cartData,
  productsData,
  addOrderToCart,
  orderBuilderData,
  orderBuilderStatus,
  checkboxSettingsData,
  checkboxSettingsStatus,
  profileData,
  loadOrderBuilder,
  loadCheckboxSettings,
}) => {
  let history = useHistory();
  const { categoryId, productId, itemId } = useParams();
  const initialProductCategory = productId;
  const initialModelCode = itemId;

  // State used on this page. Split into groups of components
  const [rightSelectedModel, setRightSelectedModel] = useState({});
  const [leftSelectedModel, setLeftSelectedModel] = useState({});
  const [rightSelected, setRightSelected] = useState(false);
  const [leftSelected, setLeftSelected] = useState(false);
  const [hearingAidSerialNumberLeft, setHearingAidSerialNumberLeft] =
    useState("");
  const [hearingAidSerialNumberRight, setHearingAidSerialNumberRight] =
    useState("");
  const [earmouldShellSerialNumberLeft, setEarmouldShellSerialNumberLeft] =
    useState("");
  const [earmouldShellSerialNumberRight, setEarmouldShellSerialNumberRight] =
    useState("");

  const [selectedModel, setSelectedModel] = useState(false);

  const [fitRetention, setFitRetention] = useState(false);
  const [fitTight, setFitTight] = useState(false);
  const [feedback, setFeedback] = useState(false);
  const [difficultyWithInsertion, setDifficultyWithInsertion] = useState(false);
  const [cosmeticReasons, setCosmeticReasons] = useState(false);
  const [broken, setBroken] = useState(false);
  const [occlusion, setOcclusion] = useState(false);
  const [other, setOther] = useState(false);

  const [otherNotes, setOtherNotes] = useState("");

  // Reasons list (keys are stable IDs; labels are what users see)
  const [deviceDead, setDeviceDead] = useState(false);
  const [intermittent, setIntermittent] = useState(false);
  const [notCharging, setNotCharging] = useState(false);
  const [distorted, setDistorted] = useState(false);
  const [highBatteryDrain, setHighBatteryDrain] = useState(false);
  const [damagedHousing, setDamagedHousing] = useState(false);
  const [noisyCrackling, setNoisyCrackling] = useState(false);
  const [damagedRemovalLine, setDamagedRemovalLine] = useState(false);
  const [noisyStaticHissing, setNoisyStaticHissing] = useState(false);
  const [damagedReceiverWire, setDamagedReceiverWire] = useState(false);
  const [weakLowOutput, setWeakLowOutput] = useState(false);
  const [cleanFunctionalCheck, setCleanFunctionalCheck] = useState(false);
  const [bluetoothConnectivityIssue, setBluetoothConnectivityIssue] =
    useState(false);
  const [repairOther, setRepairOther] = useState(false);

  const [repairOtherNotes, setRepairOtherNotes] = useState("");

  const [
    addtionalInformationCheckboxChecked,
    setAddtionalInformationCheckboxChecked,
  ] = useState([]);
  const [checkboxList, setCheckboxList] = useState([]);
  const [checkboxListUpdated, setCheckboxListUpdated] = useState(false);

  const [showAdditionalNotes, setShowAdditionalNotes] = useState(false);

  const [currentWearer, setCurrentWearer] = useState(false);

  const [enable, setEnable] = useState(false);
  const [veteransAffairs, setVeteransAffairs] = useState(false);
  const [insurance, setInsurance] = useState(false);

  const [enableCheckoutButton, setEnableCheckoutButton] = useState(false);

  const [earImpressionForOrder, setEarImpressionForOrder] = useState(false);

  const [hideVACheckbox, setHideVACheckbox] = useState(false);

  // --- NEW REQUEST TYPES ---
  const SECTION = {
    RepairHearingAid: "Repair - Hearing Aid(s)",
    RepairCustomShell: "Repair - Custom Earmould/Shell",
    RepairAccessoryRogerOther: "Repair - Accessory/Roger/Charger/Other",
    ReshellRemake: "Reshell or remake",
    RemoteRicReceiverReplacement: "Remote RIC Receiver Replacement",
  };

  // Initial selection state: all off
  const [sections, setSections] = useState({
    RepairHearingAid: false,
    RepairCustomShell: false,
    RepairAccessoryRogerOther: false,
    ReshellRemake: false,
    RemoteRicReceiverReplacement: false,
  });

  const isSelected = (key) => !!sections[key];

  // Any “repair” type selected? (show the Repair section once)
  const anyRepairSelected =
    sections.RepairHearingAid ||
    sections.RepairCustomShell ||
    sections.RepairAccessoryRogerOther;

  // Selection rules:
  // - Remote RIC is mutually exclusive with all others
  // - The first four can be combined freely with each other
  const toggleSection = (key) => {
    setSections((prev) => {
      const next = { ...prev, [key]: !prev[key] };

      if (key === "RemoteRicReceiverReplacement" && next[key]) {
        // turn off all others
        next.RepairHearingAid = false;
        next.RepairCustomShell = false;
        next.RepairAccessoryRogerOther = false;
        next.ReshellRemake = false;
      }

      if (
        (key === "RepairHearingAid" ||
          key === "RepairCustomShell" ||
          key === "RepairAccessoryRogerOther" ||
          key === "ReshellRemake") &&
        next[key]
      ) {
        // turn off Remote RIC
        next.RemoteRicReceiverReplacement = false;
      }

      return next;
    });
  };

  // Remote RIC (per side)
  const [ricLeft, setRicLeft] = useState({
    length: "",
    strength: "",
    generation: "",
  });
  const [ricRight, setRicRight] = useState({
    length: "",
    strength: "",
    generation: "",
  });

  const receiverLengthsForGeneration = (generation) => {
    // Only Gen 6.0 supports "00"
    if (generation === "6.0") return ["00", "0", "1", "2", "3"];
    return ["0", "1", "2", "3"];
  };

  const receiverStrengths = ["S", "M", "P"];
  const generations = ["5.0", "6.0"];

  const hasLeftSN = hearingAidSerialNumberLeft.trim() !== "";
  const hasRightSN = hearingAidSerialNumberRight.trim() !== "";

  // simple free-text model fields
  const [rightEarModel, setRightEarModel] = useState("");
  const [leftEarModel, setLeftEarModel] = useState("");

  const anyRepairReason =
    deviceDead ||
    intermittent ||
    notCharging ||
    distorted ||
    highBatteryDrain ||
    damagedHousing ||
    noisyCrackling ||
    damagedRemovalLine ||
    noisyStaticHissing ||
    damagedReceiverWire ||
    weakLowOutput ||
    cleanFunctionalCheck ||
    bluetoothConnectivityIssue ||
    repairOther;

  const anyReshellReason =
    fitRetention ||
    fitTight ||
    feedback ||
    difficultyWithInsertion ||
    cosmeticReasons ||
    broken ||
    occlusion ||
    other;

  // At least one repair reason is required if any Repair-* type selected
  const repairRequired = anyRepairSelected && !anyRepairReason;

  const reshellRequired = isSelected("ReshellRemake") && !anyReshellReason;

  const noSectionSelected = Object.values(sections).every((v) => !v);

  // --- MANDATORY FIELD RULES (per your table) ---
  // Hearing Aid S/N required if: Repair - Hearing Aid(s) OR Remote RIC
  const needHearingAidSN =
    sections.RepairHearingAid || sections.RemoteRicReceiverReplacement;

  // Custom Earmould/Shell S/N required if: Repair - Custom Earmould/Shell OR Reshell or remake
  const needShellSN = sections.RepairCustomShell || sections.ReshellRemake;

  // HTML "required" can't do "at least one of two" directly,
  // so require each field iff the *other side* is empty:
  const requireRightHASN =
    needHearingAidSN && hearingAidSerialNumberLeft.trim() === "";
  const requireLeftHASN =
    needHearingAidSN && hearingAidSerialNumberRight.trim() === "";

  const requireRightShellSN =
    needShellSN && earmouldShellSerialNumberLeft.trim() === "";
  const requireLeftShellSN =
    needShellSN && earmouldShellSerialNumberRight.trim() === "";

  useEffect(() => {
    setHideVACheckbox(false);
    if (profileData && profileData.IsSpecsavers) {
      setHideVACheckbox(true);
    }
  }, [profileData]);

  useEffect(() => {
    if (checkboxListUpdated) {
      const indexOfOther = checkboxList.indexOf("Other");
      if (addtionalInformationCheckboxChecked[indexOfOther]) {
        setShowAdditionalNotes(true);
      } else {
        setShowAdditionalNotes(false);
      }
    }
  }, [addtionalInformationCheckboxChecked, checkboxListUpdated, checkboxList]);

  useEffect(() => {
    if (checkboxSettingsData && checkboxSettingsData.includes("{")) {
      // set checkbox list
      let splitCheckboxData = checkboxSettingsData
        .replace("{", "")
        .replace("}", "")
        .split(",");
      splitCheckboxData = splitCheckboxData.map((item) => item.trim());
      setCheckboxList(splitCheckboxData);
      setCheckboxListUpdated(true);

      // set initial state for checkbox list
      let tempCheckboxListData = [];
      splitCheckboxData.forEach((_, index) => {
        tempCheckboxListData[index] = false;
      });
      setAddtionalInformationCheckboxChecked(tempCheckboxListData);
    }
  }, [checkboxSettingsData]);

  // Enable checkout when any request type is selected (submit guards handle the rest)
  useEffect(() => {
    const enabled =
      sections.RepairHearingAid ||
      sections.RepairCustomShell ||
      sections.RepairAccessoryRogerOther ||
      sections.ReshellRemake ||
      sections.RemoteRicReceiverReplacement;
    setEnableCheckoutButton(enabled);
  }, [sections]);

  function setCheckedForEachCheckbox(index, value) {
    setAddtionalInformationCheckboxChecked((prevState) => {
      let tempArray = [...prevState];
      tempArray[index] = value;
      return tempArray;
    });
  }

  function capitalizeFirstLetter(val) {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
  }

  // copy helpers for Hearing Aid Model
  const copyLeftModelToRight = () => setRightEarModel(leftEarModel);
  const copyRightModelToLeft = () => setLeftEarModel(rightEarModel);

  const goToCart = (e) => {
    e.preventDefault();

    // Require at least one request type
    if (noSectionSelected) {
      alert("Please select at least one request type.");
      return;
    }

    // Require at least one repair reason if any Repair-* group selected
    if (anyRepairSelected && !anyRepairReason) {
      alert("Please select at least one reason for repair.");
      return;
    }

    // Enforce “at least one of the pair” for S/Ns when needed
    if (
      needHearingAidSN &&
      hearingAidSerialNumberLeft.trim() === "" &&
      hearingAidSerialNumberRight.trim() === ""
    ) {
      alert(
        "Please enter at least one Hearing Aid Serial Number (left or right)."
      );
      return;
    }

    if (
      needShellSN &&
      earmouldShellSerialNumberLeft.trim() === "" &&
      earmouldShellSerialNumberRight.trim() === ""
    ) {
      alert(
        "Please enter at least one Custom Earmould/Shell Serial Number (left or right)."
      );
      return;
    }

    if (!enableCheckoutButton) return;

    const {
      rightEar,
      leftEar,
      hearingAidSerialNumberRight: hasnr,
      hearingAidSerialNumberLeft: hasnl,
      earmouldShellRight: esr,
      earmouldShellLeft: esl,
      Accessories,
      Roger,
      ChargerOptions,
      AdditionalInformation,
    } = document.forms[0];

    // Ear Impression validations (only when shell S/N provided)
    if (earImpressionForOrder?.left?.type === "impressionOnFile") {
      if (!earImpressionForOrder.left.serialNumber) {
        alert(
          "You selected to use an impression on file for the left ear but the serial number field is empty. Please enter a serial number."
        );
        return;
      }
    }

    if (earImpressionForOrder?.right?.type === "impressionOnFile") {
      if (!earImpressionForOrder.right.serialNumber) {
        alert(
          "You selected to use an impression on file for the right ear but the serial number field is empty. Please enter a serial number."
        );
        return;
      }
    }

    // Build Ear Impression strings for payload (optional)
    let RightEarImpression = "";
    if (earmouldShellSerialNumberRight.trim() !== "") {
      if (earImpressionForOrder?.right) {
        if (earImpressionForOrder.right.type === "impressionOnFile") {
          RightEarImpression = earImpressionForOrder.right.serialNumber;
        } else if (earImpressionForOrder.right.type === "mailImpression") {
          RightEarImpression = "Mail in an impression";
        } else if (earImpressionForOrder.right.type === "scanAttached") {
          RightEarImpression = "Use the scan attached";
        }
      }
    }

    let LeftEarImpression = "";
    if (earmouldShellSerialNumberLeft.trim() !== "") {
      if (earImpressionForOrder?.left) {
        if (earImpressionForOrder.left.type === "impressionOnFile") {
          LeftEarImpression = earImpressionForOrder.left.serialNumber;
        } else if (earImpressionForOrder.left.type === "mailImpression") {
          LeftEarImpression = "Mail in an impression";
        } else if (earImpressionForOrder.left.type === "scanAttached") {
          LeftEarImpression = "Use the scan attached";
        }
      }
    }

    const additionalInformationText = showAdditionalNotes
      ? AdditionalInformation.value
      : "";

    // const selectedSection = Object.keys(sections)
    //   .filter((k) => sections[k])
    //   .map((k) => SECTION[k])
    //   .join(","); // e.g. "Repair - Hearing Aid(s), Reshell or remake"
    // --- decide OrderType(s) ---
    const hasRepair =
      sections.RepairHearingAid ||
      sections.RepairCustomShell ||
      sections.RepairAccessoryRogerOther;

    const hasReshell = sections.ReshellRemake;
    const hasRemoteRic = sections.RemoteRicReceiverReplacement;

    // Build array of order types based on what's selected
    const orderTypes = [];

    if (hasRepair) orderTypes.push("Repair");
    if (hasReshell) orderTypes.push("ReshellRemake");
    if (hasRemoteRic) orderTypes.push("RemoteRicReceiverReplacement");

    // Join into comma-separated string (e.g. "Repair,ReshellRemake")
    const selectedSection = orderTypes.join(",");

    const emptyRepairReasons = {
      DeviceDead: false,
      Intermittent: false,
      NotCharging: false,
      Distorted: false,
      HighBatteryDrain: false,
      DamagedHousing: false,
      NoisyCrackling: false,
      DamagedRemovalLine: false,
      NoisyStatic: false,
      DamagedReceiverWire: false,
      WeakOutput: false,
      CleanFunctionalCheck: false,
      BluetoothIssue: false,
      Other: "",
    };

    const emptyReshellReasons = {
      FitRetention: false,
      FitTight: false,
      Feedback: false,
      DifficultyWithInsertion: false,
      CosmeticReasons: false,
      Broken: false,
      Occlusion: false,
      Other: "",
    };

    // Build ReasonForRepair for ANY repair type selection
    const reasonForRepair = anyRepairSelected
      ? {
          DeviceDead: deviceDead,
          Intermittent: intermittent,
          NotCharging: notCharging,
          Distorted: distorted,
          HighBatteryDrain: highBatteryDrain,
          DamagedHousing: damagedHousing,
          NoisyCrackling: noisyCrackling,
          DamagedRemovalLine: damagedRemovalLine,
          NoisyStatic: noisyStaticHissing,
          DamagedReceiverWire: damagedReceiverWire,
          WeakOutput: weakLowOutput,
          CleanFunctionalCheck: cleanFunctionalCheck,
          BluetoothIssue: bluetoothConnectivityIssue,
          Other: repairOther ? repairOtherNotes.trim() : "",
        }
      : { ...emptyRepairReasons };

    // Build ReasonForReshellOrRemake safely
    const reasonForReshell = isSelected("ReshellRemake")
      ? {
          FitRetention: fitRetention,
          FitTight: fitTight,
          Feedback: feedback,
          DifficultyWithInsertion: difficultyWithInsertion,
          CosmeticReasons: cosmeticReasons,
          Broken: broken,
          Occlusion: occlusion,
          Other: other ? otherNotes.trim() : "",
        }
      : { ...emptyReshellReasons };

    // Build Remote RIC safely (null if not selected)
    const remoteRicData = isSelected("RemoteRicReceiverReplacement")
      ? {
          Left: hasLeftSN
            ? {
                ReceiverLength: ricLeft.length || "",
                ReceiverStrength: ricLeft.strength || "",
                Generation: ricLeft.generation || "",
              }
            : null,
          Right: hasRightSN
            ? {
                ReceiverLength: ricRight.length || "",
                ReceiverStrength: ricRight.strength || "",
                Generation: ricRight.generation || "",
              }
            : null,
        }
      : null;

    const repairRemakeFormObject = {
      OrderType: selectedSection,
      RightModel: rightEar?.value ?? rightEarModel,
      RightModelCode: rightEar?.value ?? rightEarModel,
      LeftModel: leftEar?.value ?? leftEarModel,
      LeftModelCode: leftEar?.value ?? leftEarModel,
      RightSerialNumber: hasnr?.value ?? hearingAidSerialNumberRight,
      LeftSerialNumber: hasnl?.value ?? hearingAidSerialNumberLeft,
      LeftEarmouldShells: esl?.value ?? earmouldShellSerialNumberLeft,
      RightEarmouldShells: esr?.value ?? earmouldShellSerialNumberRight,
      AccessoriesCount: Accessories?.value ?? "0",
      RogerCount: Roger?.value ?? "0",
      ChargerOptionsCount: ChargerOptions?.value ?? "0",
      ReasonForRepair: reasonForRepair,
      ReasonForReshellOrRemake: reasonForReshell,
      RemoteRICReceiverReplacementData: remoteRicData,
      IsCurrentPhonakHearingAidWearer: currentWearer,
      AdditionalInformation: additionalInformationText,
      AdditionalInformationCheckbox: addtionalInformationCheckboxChecked,
      IsEnable: enable,
      IsVeteransAffairsClient: veteransAffairs,
      IsInsurance: insurance,
      RightEarImpression: RightEarImpression,
      LeftEarImpression: LeftEarImpression,
    };

    history.push({
      pathname: "/Repair/Repair/checkout",
      state: { repairRemakeFormObject },
    });
  };

  return (
    <div className="order-builder-main-div repair-main-div">
      <h1>Repair / Remake</h1>
      <div>
        <div>
          {/* Family/model pickers were previously used — inputs now free text */}
          <form onSubmit={goToCart}>
            <table className="w-100 mt-5 layout-fixed">
              <colgroup>
                <col className="label-col" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th>Hearing Aid Model:</th>
                  <td>
                    <div className="row">
                      <div className="col-6">
                        <label htmlFor="RightEar">Right Ear</label>
                        <Form.Control
                          type="text"
                          name="rightEar"
                          className="me-2"
                          aria-label="rightEar"
                          value={rightEarModel}
                          onChange={(e) => setRightEarModel(e.target.value)}
                        />
                      </div>
                      <div className="col-6">
                        <label htmlFor="LeftEar">Left Ear</label>
                        <Form.Control
                          type="text"
                          name="leftEar"
                          className="me-2"
                          aria-label="leftEar"
                          value={leftEarModel}
                          onChange={(e) => setLeftEarModel(e.target.value)}
                        />
                      </div>
                      <div className="col-12 text-center hearing-aid-model-copy">
                        <p>
                          <a
                            className="copy-button"
                            role="button"
                            onClick={copyLeftModelToRight}
                            title="Copy left model → right"
                          >
                            {"<"}
                          </a>{" "}
                          Copy{" "}
                          <a
                            className="copy-button"
                            role="button"
                            onClick={copyRightModelToLeft}
                            title="Copy right model → left"
                          >
                            {">"}
                          </a>
                        </p>
                      </div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <th>Hearing Aid S/N:</th>
                  <td>
                    <div className="row">
                      <div className="col-6">
                        <label htmlFor="RightEarSerialNumber">Right Ear</label>
                        <Form.Control
                          type="text"
                          name="hearingAidSerialNumberRight"
                          className="me-2"
                          aria-label="hearingAidSerialNumberRight"
                          required={requireRightHASN}
                          onChange={(e) => {
                            setHearingAidSerialNumberRight(e.target.value);
                            setRightSelected(e.target.value.trim() !== "");
                          }}
                        />
                      </div>
                      <div className="col-6">
                        <label htmlFor="LeftEarSerialNumber">Left Ear</label>
                        <Form.Control
                          type="text"
                          name="hearingAidSerialNumberLeft"
                          className="me-2"
                          aria-label="hearingAidSerialNumberLeft"
                          required={requireLeftHASN}
                          onChange={(e) => {
                            setHearingAidSerialNumberLeft(e.target.value);
                            setLeftSelected(e.target.value.trim() !== "");
                          }}
                        />
                      </div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <th>Custom Earmould/Shell S/N:</th>
                  <td>
                    <div className="row">
                      <div className="col-6">
                        <label htmlFor="earmouldShellRight">Right Ear</label>
                        <Form.Control
                          type="text"
                          name="earmouldShellRight"
                          className="me-2"
                          aria-label="earmouldShellRight"
                          required={requireRightShellSN}
                          onChange={(e) =>
                            setEarmouldShellSerialNumberRight(e.target.value)
                          }
                        />
                      </div>
                      <div className="col-6">
                        <label htmlFor="earmouldShellLeft">Left Ear</label>
                        <Form.Control
                          type="text"
                          name="earmouldShellLeft"
                          className="me-2"
                          aria-label="earmouldShellLeft"
                          required={requireLeftShellSN}
                          onChange={(e) =>
                            setEarmouldShellSerialNumberLeft(e.target.value)
                          }
                        />
                      </div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <th>Accessory item count</th>
                  <td>
                    <Form.Control
                      type="number"
                      name="Accessories"
                      className="me-2 number-input"
                      aria-label="Accessories"
                      min="0"
                      max="5"
                    />
                  </td>
                </tr>
                <tr>
                  <th>Roger item count</th>
                  <td>
                    <Form.Control
                      type="number"
                      name="Roger"
                      className="me-2 number-input"
                      aria-label="Roger"
                      min="0"
                      max="5"
                    />
                  </td>
                </tr>
                <tr>
                  <th>Charger item count</th>
                  <td>
                    <Form.Control
                      type="number"
                      name="ChargerOptions"
                      className="me-2 number-input"
                      aria-label="ChargerOptions"
                      min="0"
                      max="5"
                    />
                  </td>
                </tr>

                {/* Section selector (checkbox UI, radio behavior) */}
                <tr>
                  <th>Select request type:</th>
                  <td>
                    <div className="row reshell-or-remake-checkboxes mb-4">
                      <div className="col-12">
                        <input
                          type="checkbox"
                          id="RepairHearingAid"
                          checked={isSelected("RepairHearingAid")}
                          onChange={() => toggleSection("RepairHearingAid")}
                          required={noSectionSelected}
                          disabled={isSelected("RemoteRicReceiverReplacement")}
                        />
                        <label htmlFor="RepairHearingAid" className="ms-2">
                          {SECTION.RepairHearingAid}
                        </label>
                      </div>

                      <div className="col-12">
                        <input
                          type="checkbox"
                          id="RepairCustomShell"
                          checked={isSelected("RepairCustomShell")}
                          onChange={() => toggleSection("RepairCustomShell")}
                          required={noSectionSelected}
                          disabled={isSelected("RemoteRicReceiverReplacement")}
                        />
                        <label htmlFor="RepairCustomShell" className="ms-2">
                          {SECTION.RepairCustomShell}
                        </label>
                      </div>

                      <div className="col-12">
                        <input
                          type="checkbox"
                          id="RepairAccessoryRogerOther"
                          checked={isSelected("RepairAccessoryRogerOther")}
                          onChange={() =>
                            toggleSection("RepairAccessoryRogerOther")
                          }
                          required={noSectionSelected}
                          disabled={isSelected("RemoteRicReceiverReplacement")}
                        />
                        <label
                          htmlFor="RepairAccessoryRogerOther"
                          className="ms-2"
                        >
                          {SECTION.RepairAccessoryRogerOther}
                        </label>
                      </div>

                      <div className="col-12">
                        <input
                          type="checkbox"
                          id="ReshellRemake"
                          checked={isSelected("ReshellRemake")}
                          onChange={() => toggleSection("ReshellRemake")}
                          required={noSectionSelected}
                          disabled={isSelected("RemoteRicReceiverReplacement")}
                        />
                        <label htmlFor="ReshellRemake" className="ms-2">
                          {SECTION.ReshellRemake}
                        </label>
                      </div>

                      <div className="col-12">
                        <input
                          type="checkbox"
                          id="RemoteRicReceiverReplacement"
                          checked={isSelected("RemoteRicReceiverReplacement")}
                          onChange={() =>
                            toggleSection("RemoteRicReceiverReplacement")
                          }
                          required={noSectionSelected}
                          disabled={
                            isSelected("RepairHearingAid") ||
                            isSelected("RepairCustomShell") ||
                            isSelected("RepairAccessoryRogerOther") ||
                            isSelected("ReshellRemake")
                          }
                        />
                        <label
                          htmlFor="RemoteRicReceiverReplacement"
                          className="ms-2"
                        >
                          {SECTION.RemoteRicReceiverReplacement}
                        </label>
                      </div>
                    </div>
                  </td>
                </tr>

                {/* CHECKBOX SECTION for Repair (shown once) */}
                {anyRepairSelected && (
                  <>
                    <tr>
                      <h2>Repair</h2>
                    </tr>
                    <tr>
                      <th>Reason for repair</th>
                      <td>
                        <div className="row">
                          <div className="col-6">
                            <div className="row reshell-or-remake-checkboxes">
                              <div className="col-12">
                                <input
                                  type="checkbox"
                                  id="deviceDead"
                                  name="repairReason"
                                  checked={deviceDead}
                                  onChange={() => setDeviceDead(!deviceDead)}
                                  required={repairRequired}
                                />
                                <label htmlFor="deviceDead">Device Dead</label>
                              </div>
                              <div className="col-12">
                                <input
                                  type="checkbox"
                                  id="notCharging"
                                  name="repairReason"
                                  checked={notCharging}
                                  onChange={() => setNotCharging(!notCharging)}
                                  required={repairRequired}
                                />
                                <label htmlFor="notCharging">
                                  Not Charging
                                </label>
                              </div>
                              <div className="col-12">
                                <input
                                  type="checkbox"
                                  id="highBatteryDrain"
                                  name="repairReason"
                                  checked={highBatteryDrain}
                                  onChange={() =>
                                    setHighBatteryDrain(!highBatteryDrain)
                                  }
                                  required={repairRequired}
                                />
                                <label htmlFor="highBatteryDrain">
                                  High Battery Drain
                                </label>
                              </div>
                              <div className="col-12">
                                <input
                                  type="checkbox"
                                  id="noisyCrackling"
                                  name="repairReason"
                                  checked={noisyCrackling}
                                  onChange={() =>
                                    setNoisyCrackling(!noisyCrackling)
                                  }
                                  required={repairRequired}
                                />
                                <label htmlFor="noisyCrackling">
                                  Noisy: Crackling
                                </label>
                              </div>
                              <div className="col-12">
                                <input
                                  type="checkbox"
                                  id="noisyStatic"
                                  name="repairReason"
                                  checked={noisyStaticHissing}
                                  onChange={() =>
                                    setNoisyStaticHissing(!noisyStaticHissing)
                                  }
                                  required={repairRequired}
                                />
                                <label htmlFor="noisyStatic">
                                  Noisy: Static/Hissing
                                </label>
                              </div>
                              <div className="col-12">
                                <input
                                  type="checkbox"
                                  id="weakLowOutput"
                                  name="repairReason"
                                  checked={weakLowOutput}
                                  onChange={() =>
                                    setWeakLowOutput(!weakLowOutput)
                                  }
                                  required={repairRequired}
                                />
                                <label htmlFor="weakLowOutput">
                                  Weak/Low Output
                                </label>
                              </div>
                              <div className="col-12">
                                <input
                                  type="checkbox"
                                  id="bluetoothConnectivityIssue"
                                  name="repairReason"
                                  checked={bluetoothConnectivityIssue}
                                  onChange={() =>
                                    setBluetoothConnectivityIssue(
                                      !bluetoothConnectivityIssue
                                    )
                                  }
                                  required={repairRequired}
                                />
                                <label htmlFor="bluetoothConnectivityIssue">
                                  Bluetooth Connectivity Issue
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="row reshell-or-remake-checkboxes">
                              <div className="col-12">
                                <input
                                  type="checkbox"
                                  id="intermittent"
                                  name="repairReason"
                                  checked={intermittent}
                                  onChange={() =>
                                    setIntermittent(!intermittent)
                                  }
                                  required={repairRequired}
                                />
                                <label htmlFor="intermittent">
                                  Intermittent
                                </label>
                              </div>
                              <div className="col-12">
                                <input
                                  type="checkbox"
                                  id="distorted"
                                  name="repairReason"
                                  checked={distorted}
                                  onChange={() => setDistorted(!distorted)}
                                  required={repairRequired}
                                />
                                <label htmlFor="distorted">Distorted</label>
                              </div>
                              <div className="col-12">
                                <input
                                  type="checkbox"
                                  id="damagedHousing"
                                  name="repairReason"
                                  checked={damagedHousing}
                                  onChange={() =>
                                    setDamagedHousing(!damagedHousing)
                                  }
                                  required={repairRequired}
                                />
                                <label htmlFor="damagedHousing">
                                  Damaged Housing
                                </label>
                              </div>
                              <div className="col-12">
                                <input
                                  type="checkbox"
                                  id="damagedRemovalLine"
                                  name="repairReason"
                                  checked={damagedRemovalLine}
                                  onChange={() =>
                                    setDamagedRemovalLine(!damagedRemovalLine)
                                  }
                                  required={repairRequired}
                                />
                                <label htmlFor="damagedRemovalLine">
                                  Damaged Removal Line
                                </label>
                              </div>
                              <div className="col-12">
                                <input
                                  type="checkbox"
                                  id="damagedReceiverWire"
                                  name="repairReason"
                                  checked={damagedReceiverWire}
                                  onChange={() =>
                                    setDamagedReceiverWire(!damagedReceiverWire)
                                  }
                                  required={repairRequired}
                                />
                                <label htmlFor="damagedReceiverWire">
                                  Damaged Receiver Wire
                                </label>
                              </div>
                              <div className="col-12">
                                <input
                                  type="checkbox"
                                  id="cleanFunctionalCheck"
                                  name="repairReason"
                                  checked={cleanFunctionalCheck}
                                  onChange={() =>
                                    setCleanFunctionalCheck(
                                      !cleanFunctionalCheck
                                    )
                                  }
                                  required={repairRequired}
                                />
                                <label htmlFor="cleanFunctionalCheck">
                                  Clean & Functional Check
                                </label>
                              </div>
                              <div className="col-12">
                                <input
                                  type="checkbox"
                                  id="repairOther"
                                  name="repairReason"
                                  checked={repairOther}
                                  onChange={() => setRepairOther(!repairOther)}
                                  required={repairRequired}
                                />
                                <label htmlFor="repairOther">Other</label>

                                {repairOther && (
                                  <div>
                                    <label
                                      htmlFor="repairOtherNotes"
                                      className="sr-only"
                                    >
                                      Other details
                                    </label>
                                    <textarea
                                      id="repairOtherNotes"
                                      rows="3"
                                      className="w-100"
                                      value={repairOtherNotes}
                                      onChange={(e) =>
                                        setRepairOtherNotes(e.target.value)
                                      }
                                      required={repairRequired}
                                    />
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </>
                )}

                {/* CHECKBOX SECTION for Reshell or Remake */}
                {isSelected("ReshellRemake") && (
                  <>
                    <tr>
                      <h2>Reshell or Remake</h2>
                    </tr>
                    <tr>
                      <th>Reason for Reshell or Remake</th>
                      <td>
                        <div className="row">
                          <div className="col-6">
                            <div className="row reshell-or-remake-checkboxes">
                              <div className="col-12">
                                <input
                                  type="checkbox"
                                  id="FitRetention"
                                  checked={fitRetention}
                                  onChange={() =>
                                    setFitRetention(!fitRetention)
                                  }
                                  required={reshellRequired}
                                />
                                <label htmlFor="FitRetention">
                                  Fit - Retention
                                </label>
                              </div>
                              <div className="col-12">
                                <input
                                  type="checkbox"
                                  id="FitTight"
                                  checked={fitTight}
                                  onChange={() => setFitTight(!fitTight)}
                                  required={reshellRequired}
                                />
                                <label htmlFor="FitTight">Fit - Tight</label>
                              </div>
                              <div className="col-12">
                                <input
                                  type="checkbox"
                                  id="Feedback"
                                  checked={feedback}
                                  onChange={() => setFeedback(!feedback)}
                                  required={reshellRequired}
                                />
                                <label htmlFor="Feedback">Feedback</label>
                              </div>
                              <div className="col-12">
                                <input
                                  type="checkbox"
                                  id="DifficultyWithInsertion "
                                  checked={difficultyWithInsertion}
                                  onChange={() =>
                                    setDifficultyWithInsertion(
                                      !difficultyWithInsertion
                                    )
                                  }
                                  required={reshellRequired}
                                />
                                <label htmlFor="DifficultyWithInsertion">
                                  Difficulty with Insertion
                                </label>
                              </div>
                              <div className="col-12">
                                <input
                                  type="checkbox"
                                  id="CosmeticReasons"
                                  checked={cosmeticReasons}
                                  onChange={() =>
                                    setCosmeticReasons(!cosmeticReasons)
                                  }
                                  required={reshellRequired}
                                />
                                <label htmlFor="CosmeticReasons">
                                  Cosmetic Reasons
                                </label>
                              </div>
                              <div className="col-12">
                                <input
                                  type="checkbox"
                                  id="Broken"
                                  checked={broken}
                                  onChange={() => setBroken(!broken)}
                                  required={reshellRequired}
                                />
                                <label htmlFor="Broken">Broken</label>
                              </div>
                              <div className="col-12">
                                <input
                                  type="checkbox"
                                  id="Occlusion"
                                  checked={occlusion}
                                  onChange={() => setOcclusion(!occlusion)}
                                  required={reshellRequired}
                                />
                                <label htmlFor="Occlusion">Occlusion</label>
                              </div>

                              <div className="col-12">
                                <input
                                  type="checkbox"
                                  id="Other"
                                  checked={other}
                                  onChange={() => setOther(!other)}
                                  required={reshellRequired}
                                />
                                <label htmlFor="Other">Other</label>

                                {other && (
                                  <div>
                                    <label
                                      htmlFor="OtherNotes"
                                      className="sr-only"
                                    >
                                      Other details
                                    </label>
                                    <textarea
                                      id="OtherNotes"
                                      rows="3"
                                      className="w-100"
                                      value={otherNotes}
                                      onChange={(e) =>
                                        setOtherNotes(e.target.value)
                                      }
                                      required={reshellRequired}
                                    />
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="col-6 reshell-or-remake-checkboxes">
                            <input
                              type="checkbox"
                              id="CurrentWearer"
                              checked={currentWearer}
                              onChange={() => setCurrentWearer(!currentWearer)}
                              required={reshellRequired}
                            />
                            <label htmlFor="CurrentWearer">
                              Current{" "}
                              {capitalizeFirstLetter(
                                config.siteName.toLowerCase()
                              )}{" "}
                              Hearing aid Wearer?
                            </label>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="2" className="repair-remake-ear-impression">
                        <EarImpression
                          leftSelected={
                            earmouldShellSerialNumberLeft.trim() !== ""
                          }
                          rightSelected={
                            earmouldShellSerialNumberRight.trim() !== ""
                          }
                          isRepairRemakeOrder={true}
                          setEarImpressionForOrder={setEarImpressionForOrder}
                        />
                      </td>
                    </tr>
                  </>
                )}

                {/* CHECKBOX SECTION for Remote RIC */}
                {isSelected("RemoteRicReceiverReplacement") && (
                  <>
                    <tr>
                      <h2>Remote RIC Receiver Replacement</h2>
                    </tr>
                    <tr>
                      <td colSpan="2">
                        <div className="alert alert-danger" role="alert">
                          <strong>Important Note:</strong> Remote Receiver
                          Replacements do not need to send the devices in.
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>Receiver Options:</th>
                      <td>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            {hasRightSN && (
                              <>
                                <h5>Right Ear</h5>

                                <Form.Group className="mb-2">
                                  <Form.Label>Receiver Length</Form.Label>
                                  <Form.Control
                                    as="select"
                                    value={ricRight.length}
                                    onChange={(e) =>
                                      setRicRight({
                                        ...ricRight,
                                        length: e.target.value,
                                      })
                                    }
                                    required={
                                      hasRightSN || (!hasLeftSN && !hasRightSN)
                                    }
                                  >
                                    <option value="">Select…</option>
                                    {receiverLengthsForGeneration(
                                      ricRight.generation
                                    ).map((v) => (
                                      <option key={v} value={v}>
                                        {v}
                                      </option>
                                    ))}
                                  </Form.Control>
                                </Form.Group>

                                <Form.Group className="mb-2">
                                  <Form.Label>Receiver Strength</Form.Label>
                                  <Form.Control
                                    as="select"
                                    value={ricRight.strength}
                                    onChange={(e) =>
                                      setRicRight({
                                        ...ricRight,
                                        strength: e.target.value,
                                      })
                                    }
                                    required={
                                      hasRightSN || (!hasLeftSN && !hasRightSN)
                                    }
                                  >
                                    <option value="">Select…</option>
                                    {receiverStrengths.map((v) => (
                                      <option key={v} value={v}>
                                        {v}
                                      </option>
                                    ))}
                                  </Form.Control>
                                </Form.Group>

                                <Form.Group>
                                  <Form.Label>Generation</Form.Label>
                                  <Form.Control
                                    as="select"
                                    value={ricRight.generation}
                                    // onChange={(e) =>
                                    //   setRicRight({
                                    //     ...ricRight,
                                    //     generation: e.target.value,
                                    //   })
                                    // }
                                    onChange={(e) => {
                                      const gen = e.target.value;

                                      setRicRight((prev) => {
                                        const allowedLengths =
                                          receiverLengthsForGeneration(gen);

                                        return {
                                          ...prev,
                                          generation: gen,
                                          length: allowedLengths.includes(
                                            prev.length
                                          )
                                            ? prev.length
                                            : "",
                                        };
                                      });
                                    }}
                                    required={
                                      hasRightSN || (!hasLeftSN && !hasRightSN)
                                    }
                                  >
                                    <option value="">Select…</option>
                                    {generations.map((v) => (
                                      <option key={v} value={v}>
                                        {v}
                                      </option>
                                    ))}
                                  </Form.Control>
                                </Form.Group>
                              </>
                            )}
                          </div>

                          <div className="col-md-6 mb-3">
                            {hasLeftSN && (
                              <>
                                <h5>Left Ear</h5>

                                <Form.Group className="mb-2">
                                  <Form.Label>Receiver Length</Form.Label>
                                  <Form.Control
                                    as="select"
                                    value={ricLeft.length}
                                    onChange={(e) =>
                                      setRicLeft({
                                        ...ricLeft,
                                        length: e.target.value,
                                      })
                                    }
                                    required={
                                      hasLeftSN || (!hasLeftSN && !hasRightSN)
                                    }
                                  >
                                    <option value="">Select…</option>
                                    {receiverLengthsForGeneration(
                                      ricLeft.generation
                                    ).map((v) => (
                                      <option key={v} value={v}>
                                        {v}
                                      </option>
                                    ))}
                                  </Form.Control>
                                </Form.Group>

                                <Form.Group className="mb-2">
                                  <Form.Label>Receiver Strength</Form.Label>
                                  <Form.Control
                                    as="select"
                                    value={ricLeft.strength}
                                    onChange={(e) =>
                                      setRicLeft({
                                        ...ricLeft,
                                        strength: e.target.value,
                                      })
                                    }
                                    required={
                                      hasLeftSN || (!hasLeftSN && !hasRightSN)
                                    }
                                  >
                                    <option value="">Select…</option>
                                    {receiverStrengths.map((v) => (
                                      <option key={v} value={v}>
                                        {v}
                                      </option>
                                    ))}
                                  </Form.Control>
                                </Form.Group>

                                <Form.Group>
                                  <Form.Label>Generation</Form.Label>
                                  <Form.Control
                                    as="select"
                                    value={ricLeft.generation}
                                    // onChange={(e) =>
                                    //   setRicLeft({
                                    //     ...ricLeft,
                                    //     generation: e.target.value,
                                    //   })
                                    // }
                                    onChange={(e) => {
                                      const gen = e.target.value;

                                      setRicLeft((prev) => {
                                        const allowedLengths =
                                          receiverLengthsForGeneration(gen);

                                        return {
                                          ...prev,
                                          generation: gen,
                                          length: allowedLengths.includes(
                                            prev.length
                                          )
                                            ? prev.length
                                            : "",
                                        };
                                      });
                                    }}
                                    required={
                                      hasLeftSN || (!hasLeftSN && !hasRightSN)
                                    }
                                  >
                                    <option value="">Select…</option>
                                    {generations.map((v) => (
                                      <option key={v} value={v}>
                                        {v}
                                      </option>
                                    ))}
                                  </Form.Control>
                                </Form.Group>
                              </>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                  </>
                )}

                {/* ////////////////////////////////////CHECKBOX IS SET HERE////////////////////////////////// */}
                <tr>
                  <th>
                    Additional Information
                    <br />
                  </th>
                  <td>
                    <div className="row">
                      <div className="col-6">
                        <div className="row reshell-or-remake-checkboxes">
                          {checkboxListUpdated
                            ? checkboxList.map((checkbox, index) => {
                                let checkboxId = checkbox.trim();
                                return (
                                  <div className="col-12" key={index}>
                                    <input
                                      type="checkbox"
                                      id={checkboxId}
                                      checked={
                                        addtionalInformationCheckboxChecked[
                                          index
                                        ] || false
                                      }
                                      onChange={() =>
                                        setCheckedForEachCheckbox(
                                          index,
                                          !addtionalInformationCheckboxChecked[
                                            index
                                          ]
                                        )
                                      }
                                    />
                                    <label htmlFor={checkboxId}>
                                      {checkbox}
                                    </label>
                                  </div>
                                );
                              })
                            : ""}
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>

                {showAdditionalNotes && (
                  <>
                    <tr style={{ border: "none" }}>
                      <td colSpan={2}>
                        <div className="alert alert-danger" role="alert">
                          <p>
                            Attention: Please only enter additional notes that
                            are critical to accurate order entry and are unable
                            to be entered elsewhere
                          </p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={2}>
                        <textarea
                          id="AdditionalInformation"
                          name="AdditionalInformation"
                          rows="8"
                          cols="100"
                        ></textarea>
                      </td>
                    </tr>
                  </>
                )}

                <tr>
                  <th>Quote required for Specific funding type:</th>
                  <td>
                    {!hideVACheckbox && (
                      <div className="row reshell-or-remake-checkboxes">
                        <div className="col-12">
                          <input
                            type="checkbox"
                            id="Enable"
                            checked={enable}
                            onChange={() => setEnable(!enable)}
                          />
                          <label htmlFor="Enable">{`Enable (H.Aid is 5+ years old) - Please quote if the repair cost is more than $235 per H.Aid`}</label>
                        </div>
                        <div className="col-12">
                          <input
                            type="checkbox"
                            id="VeteransAffairs"
                            checked={veteransAffairs}
                            onChange={() =>
                              setVeteransAffairs(!veteransAffairs)
                            }
                          />
                          <label htmlFor="VeteransAffairs">{`Veterans Affairs (H.Aid is 5+ years old) - Please qoute if the repair cost is more than $277 per H.Aid`}</label>
                        </div>
                        <div className="col-12">
                          <input
                            type="checkbox"
                            id="Insurance"
                            checked={insurance}
                            onChange={() => setInsurance(!insurance)}
                          />
                          <label htmlFor="Insurance">
                            Insurance - Please provide a quote before any repair
                            is carried out
                          </label>
                        </div>
                      </div>
                    )}
                    {hideVACheckbox && (
                      <div className="row reshell-or-remake-checkboxes">
                        <div className="col-12">
                          <input
                            type="checkbox"
                            id="Insurance"
                            checked={insurance}
                            onChange={() => setInsurance(!insurance)}
                          />
                          <label htmlFor="Insurance">
                            Insurance - Please provide a quote before any repair
                            is carried out
                          </label>
                        </div>
                      </div>
                    )}
                  </td>
                </tr>
              </tbody>
            </table>

            <Row className="go-to-cart-button-button-div mt-5">
              <Col xs={12}>
                <div className="go-to-cart-button-div">
                  <Button
                    type="submit"
                    className={`float-right ${
                      enableCheckoutButton ? "" : "disabled"
                    }`}
                    disabled={!enableCheckoutButton}
                  >
                    Checkout
                  </Button>
                </div>
              </Col>
            </Row>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RepairItemBuilder;
